<script>
	import PageSection from "../../components/PageSection.svelte";
	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	export let pageIndex = null;
	export let pageTitle = null;

	pageNumber.update((p) => pageIndex);
	document.title = pageTitle;

	window.onbeforeunload = null;
</script>

<PageSection>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<h1>Thank you</h1>

			<p>
				Thank you for entering into the Litigation Funding Agreement and Conditional Costs Agreement for your
				registration in the {projectSettings.classActionName}.
			</p>

			<p>
				Your registration number is: <strong>{$model.RegistrationNumber}</strong>
			</p>

			<p>
				If you have any questions, please contact Shine Lawyers on {projectSettings.phoneNumber}, or at
				<a href="mailto:{projectSettings.emailAddress}" title={projectSettings.classActionName}
					>{projectSettings.emailAddress}</a
				>, and quote the registration number above.
			</p>

			<p>
				The <a href={projectSettings.serviceUrl} title={projectSettings.classActionName}
					>{projectSettings.classActionName}</a
				>
				page on our website will be kept up to date with the latest developments in the case, so we encourage you
				to refer to the website for future case updates. If you have any questions regarding this update, please
				do not hesitate to contact us.
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2,
	h3 {
		font-size: 1.1em;
		margin-bottom: 16px;
	}

	h2 {
		font-weight: 700;
	}
</style>
